if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        
        // Thumbnail Click Listener
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch.addEventListener('click', (event) => {
            event.preventDefault();
            const targetId = mediaToSwitch.dataset.target;
            this.setActiveMedia(targetId);
            this.selectVariantFromMedia(mediaToSwitch);
          });
        });

        if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic();
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails?.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend = false) {
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        this.elements.viewer.querySelectorAll('.is-active').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia.classList.add('is-active');

        const sliderList = this.elements.viewer.querySelector('ul.slider');
        if (sliderList) {
          sliderList.scrollTo({
            left: activeMedia.offsetLeft,
            behavior: 'smooth'
          });
        } else {
          activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }

        const activeThumbnail = this.elements.thumbnails?.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail) {
          this.setActiveThumbnail(activeThumbnail);
        }

        this.preventStickyHeader();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));

        const button = thumbnail.querySelector('button');
        if (button) button.setAttribute('aria-current', 'true');

        thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }

      selectVariantFromMedia(mediaElement) {
        const opt1 = mediaElement.getAttribute('data-variant-option1');
        const opt2 = mediaElement.getAttribute('data-variant-option2');
        const opt3 = mediaElement.getAttribute('data-variant-option3');
        const optionsToSelect = [opt1, opt2, opt3].filter(Boolean);

        if (optionsToSelect.length === 0) return;

        optionsToSelect.forEach((optionValue) => {
          // ১. Radio / Swatches Input (Dawn Theme 12+)
          const radioInput = document.querySelector(
            `variant-radios input[value="${CSS.escape(optionValue)}"], product-info input[value="${CSS.escape(optionValue)}"]`
          );

          if (radioInput) {
            if (!radioInput.checked) {
              radioInput.checked = true;
              radioInput.dispatchEvent(new Event('change', { bubbles: true }));
              radioInput.dispatchEvent(new Event('input', { bubbles: true }));
            }
            return;
          }

          // ২. Select Dropdown (Native Dropdown)
          const selectOptions = document.querySelectorAll(
            `variant-selects option[value="${CSS.escape(optionValue)}"], product-info select option[value="${CSS.escape(optionValue)}"]`
          );

          selectOptions.forEach((option) => {
            const selectElement = option.closest('select');
            if (selectElement && selectElement.value !== optionValue) {
              selectElement.value = optionValue;
              selectElement.dispatchEvent(new Event('change', { bubbles: true }));
              selectElement.dispatchEvent(new Event('input', { bubbles: true }));
            }
          });
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}